import { HpSvgIconTypes, SvgIcon } from '@avantia/style-guide';

import './paymentInformation.scss';
import { InfoBox } from 'components/shared/infoBox';

interface PaymentInformationProps {
  cardNumber?: string | null;
  cardExpiry?: string | null;
  handleClickEdit: () => void;
}

export const PaymentInformation = ({
  cardNumber,
  cardExpiry,
  handleClickEdit
}: PaymentInformationProps): JSX.Element => {
  const mainText = cardNumber ? `Card ending in ${cardNumber.slice(-4)}` : '';
  const subText = cardExpiry ? `Expires ${cardExpiry}` : null;
  const actionButton = <SvgIcon type={'edit-square' as HpSvgIconTypes} className="card-icon" size="semi-tiny" />;

  return (
    <>
      <h2 className="payment-header">PAYMENT INFORMATION</h2>
      <InfoBox
        mainText={mainText}
        subText={subText}
        actionButton={actionButton}
        handleClick={handleClickEdit}
        testId="edit-button"
        icon={'credit-card' as HpSvgIconTypes}
      />
    </>
  );
};
